function checkURLParameters() {
  let e = new URLSearchParams(window.location.search);
  if (e.has("contact[tags]") && e.has("form_type")) {
    let t = e.get("contact[tags]"),
      i = e.get("form_type");
    if (t.includes("prospect") && t.includes("newsletter") && "customer" === i) {
      let s = document.querySelector(".custom-contant-already"),
        a = document.createTextNode("Ya est\xe1s suscrito con este correo electr\xf3nico.");
      if (s) {
        s.appendChild(a);
      }
    }
  }
}
if (typeof jQuery !== "undefined") {
  jQuery(document).ready(function ($) {
    if (typeof $.fn.slick !== "undefined") {
      jQuery(".mobile-view").slick({
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<button type="button" class="slick-prev">Previous</button>',
        nextArrow: '<button type="button" class="slick-next">Next</button>',
        responsive: [
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }
    $("#scroll-button").on("click", function (event) {
      event.preventDefault(); // Prevent the default action of the link

      // Get the target element by its ID
      var targetElement = $("#shopify-section-template--23386512261459__main");

      // Check if the target element exists before scrolling
      if (targetElement.length) {
        // Scroll to the target element with smooth animation
        $("html, body").animate(
          {
            scrollTop: targetElement.offset().top,
          },
          1000,
        ); // 1000ms for smooth scrolling duration
      } else {
        console.error("Target element not found.");
      }
    });

    $(".dynamic-sections .image-with-text__wrapper .buttons a.custm-spin-cls").on("click", function () {
      $("#wheelify-spin-trigger-cc").trigger("click");
    });

    window.addEventListener("load", checkURLParameters);

    $(".accordion-containercustom .accordiancstmset a").click(function (e) {
      (e.preventDefault(),
        $(this).hasClass("active")
          ? $(this).removeClass("active")
          : ($(".accordion-containercustom .accordiancstmset a").removeClass("active"), $(this).addClass("active")));
    });

    var $first = $(".accordion-containercustom .accordiancstmset").first();
    $first.find(".custom-section").addClass("active");
    $first.find(".custom-quest-answ-flx").slideDown();

    // Step 2: On accordion click
    $(".accordion-containercustom").on("click", ".custom-section", function (e) {
      e.preventDefault();

      var $this = $(this);
      var $content = $this.next(".custom-quest-answ-flx");

      // Ignore click if already active
      if ($this.hasClass("active")) {
        return;
      }

      // Close all other accordions
      $(".custom-section").removeClass("active");
      $(".custom-quest-answ-flx").stop(true, true).slideUp();

      // Open the clicked one
      $this.addClass("active");
      $content.stop(true, true).slideDown();
    });
    if (typeof $.fn.slick !== "undefined") {
      $(".owl-carousel.owl-theme").slick({
        dots: !0,
        infinite: !1,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: !0,
              dots: !0,
            },
          },
          {breakpoint: 867, settings: {slidesToShow: 2, slidesToScroll: 2}},
          {breakpoint: 767, settings: {slidesToShow: 2, slidesToScroll: 2}},
          {breakpoint: 480, settings: {slidesToShow: 1, slidesToScroll: 1}},
        ],
      });
    }
    const videos = document.querySelectorAll(".custom-video"),
      playButtons = document.querySelectorAll(".cstm-requirment");
    playButtons.forEach((e, t) => {
      e.addEventListener("click", () => {
        let i = videos[t];
        i.paused ? (i.play(), (e.style.opacity = 0)) : (i.pause(), (e.style.opacity = 1));
      });
    });

    $(document).ready(function () {
      var currentUrl = window.location.href;

      $(".main-order-custom").each(function () {
        var parentLink = $(this).closest("a").attr("href");

        if (parentLink && currentUrl.indexOf(parentLink) !== -1 && parentLink !== "/") {
          $(".main-order-custom").removeClass("active");
          $(this).addClass("active");
        }
      });

      $(".main-order-custom").click(function () {
        var index = $(".main-order-custom").index(this);
        $(".main-order-custom").removeClass("active");
        $(this).addClass("active");
        localStorage.setItem("activeElementIndex", index);
      });

      if ($(".main-order-custom.active").length === 0) {
        var storedIndex = localStorage.getItem("activeElementIndex");
        if (storedIndex !== null) {
          $(".main-order-custom").eq(storedIndex).addClass("active");
        }
      }
    });

    $(".product-details-varient").click(function () {
      var e = $(this).attr("id");
      ($(".product-details-varient").removeClass("active"), $(this).addClass("active"), console.log("Clicked variant ID: " + e));
    });

    $(".product-details-varient").click(function () {
      var e = $(this).attr("id"),
        t = $("#buy-now-link"),
        i = t.attr("href").replace(/\/\d+:/, "/" + e + ":");
      (t.attr("href", i), console.log("Updated buy now link with variant ID: " + i));
    });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  var currentUrl = window.location.pathname; // Use pathname to match the relative URL
  let colorAnchors = document.querySelectorAll(".color_anchor");

  colorAnchors.forEach((anchor) => {
    let anchorUrl = anchor.getAttribute("href"); // Use href attribute for comparison

    if (currentUrl === anchorUrl) {
      // Exact match of the pathname
      anchor.classList.add("active");
    } else {
      anchor.classList.remove("active");
    }
  });
});

let e = document.querySelectorAll("img");
e.forEach((e) => {
  e.setAttribute("loading", "lazy");
});

// Helper function to set a cookie for ACT user
function setActCookie(name, value, minutes) {
  const expires = new Date(Date.now() + minutes * 60 * 1000).toUTCString();
  document.cookie = `${name}=${value}; expires=${expires}; path=/`;
}

// Helper function to get a cookie by name
function getActCookie(name) {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? match[2] : null;
}

/*
// Check if 'isACTUser' cookie is already set
document.addEventListener("DOMContentLoaded", function () {
  // If not set, and URL contains 'atc=true', then set the cookie
  if (window.location.pathname.endsWith("/pages/6-beneficios-2-efecto")) {
    setActCookie('isACTUser', 'true', 4320);
    console.log("sssss");
    document.body.classList.add("atc-user-activate");
  }

  const isACTUserCookie = getActCookie('isACTUser');
  const body = document.body;
  if (isACTUserCookie == 'true') {
    if (!body.classList.contains("atc-user-activate")) {
      body.classList.add("atc-user-activate");
    }
  } else {
    if (body.classList.contains("atc-user-activate")) {
      body.classList.remove("atc-user-activate");
    }
  }
});*/

// Robust ATC Cookie Setter for /pages/6-beneficios-2-efecto
(function () {
  const EXPIRY_MINUTES = 14400; // 10 days in minutes
  const EXPIRY_MS = EXPIRY_MINUTES * 60 * 1000;

  function setActCookie(name, value, minutes) {
    const date = new Date();
    date.setTime(date.getTime() + minutes * 60 * 1000);
    document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/;SameSite=Lax`;
  }

  function getActCookie(name) {
    const nameEQ = name + "=";
    const parts = document.cookie.split(";");
    for (let c of parts) {
      c = c.trim();
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
    }
    return null;
  }

  const allowedEnds = ["/pages/6-beneficios-2-efecto", "/pages/8-benefits", "/products/kertox-efecto-botox-capilar-instantaneo", "/pages/articulo-pelo-silencioso"];

  if (!allowedEnds.some((end) => window.location.pathname.endsWith(end))) return;

  function applyATCActivation() {
    const now = Date.now();

    let lsValue = localStorage.getItem("isACTUser");
    let lsTime = localStorage.getItem("isACTUser_time");
    let cookieValue = getActCookie("isACTUser");

    // Check expiry for localStorage
    if (lsValue === "true" && lsTime) {
      const age = now - Number(lsTime);
      if (age > EXPIRY_MS) {
        // EXPIRED → clear LS + cookie
        localStorage.removeItem("isACTUser");
        localStorage.removeItem("isACTUser_time");
        document.cookie = "isACTUser=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;";
        lsValue = null;
        cookieValue = null;
        console.log("⛔ Expired — cleared ACT");
      }
    }

    // If triggered or first time
    if (window.location.search.includes("atc=true") || !lsValue || !cookieValue) {
      localStorage.setItem("isACTUser", "true");
      localStorage.setItem("isACTUser_time", now.toString());

      setActCookie("isACTUser", "true", EXPIRY_MINUTES);

      console.log("🔥 Set ACT (LS + Cookie) with timestamp");
      lsValue = "true";
    }

    // Apply class
    if (lsValue === "true") {
      document.body.classList.add("atc-user-activate");
    } else {
      document.body.classList.remove("atc-user-activate");
    }
  }

  applyATCActivation();

  const interval = setInterval(applyATCActivation, 2000);
  setTimeout(() => clearInterval(interval), 30000);

  document.addEventListener("DOMContentLoaded", applyATCActivation);
})();

// Helper function to get a cookie by name
function getActCookiess(name) {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? match[2] : null;
}

// Check if 'isACTUser' cookie is already set
document.addEventListener("DOMContentLoaded", function () {
  const now = Date.now();

  const isACTUserCookie = getActCookiess("isACTUser");
  const body = document.body;
  if (isACTUserCookie == "true") {
    if (!body.classList.contains("atc-user-activate")) {
      body.classList.add("atc-user-activate");
    }
  } else {
    if (body.classList.contains("atc-user-activate")) {
      body.classList.remove("atc-user-activate");
    }

    let lsValue = localStorage.getItem("isACTUser");
    let lsTime = localStorage.getItem("isACTUser_time");

    let EXPIRY_MINUTES = 14400; // 10 days in minutes
    let EXPIRY_MS = EXPIRY_MINUTES * 60 * 1000;
    // Check expiry for localStorage
    if (lsValue === "true" && lsTime) {
      const age = now - Number(lsTime);
      if (age > EXPIRY_MS) {
        // EXPIRED → clear LS + cookie
        localStorage.removeItem("isACTUser");
        localStorage.removeItem("isACTUser_time");
      } else {
        body.classList.add("atc-user-activate");
      }
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const radios = document.querySelectorAll('.custom_bundle .swatch__option input[type="radio"]');

  function applyLogic(value) {
    const customBundleForm = document.querySelector(".custom_bandle_form");
    const rechargeWidget = document.querySelector(".new-form-atc");
    const mainButtonBox = document.querySelector(".main_button_box");

    if (!customBundleForm || !rechargeWidget || !mainButtonBox || !radios.length) return;

    const isKertox = value === "1 x Kertox 30ml";

    customBundleForm.style.display = isKertox ? "block" : "none";
    rechargeWidget.style.display = isKertox ? "none" : "block";
    mainButtonBox.style.display = isKertox ? "none" : "flex";

    console.log("rechargeWidget", isKertox ? "none" : "block");

    if (isKertox) {
      console.log("Selected: 1 KERTOX 30ML");
    }
  }

  // ✅ Normal instant logic on change (NO retry here)
  radios.forEach((radio) => {
    radio.addEventListener("change", function () {
      applyLogic(this.value);
    });
  });

  // ✅ Retry logic ONLY for page load
  const checkedRadio = document.querySelector('.custom_bundle .swatch__option input[type="radio"]:checked');

  if (checkedRadio) {
    let retryCount = 0;
    const maxRetries = 10;
    const retryInterval = 1000; // total 2000ms

    const retryApplyOnLoad = () => {
      const rechargeWidget = document.querySelector(".new-form-atc");

      if (rechargeWidget || retryCount >= maxRetries) {
        applyLogic(checkedRadio.value);
        if (!rechargeWidget) {
          console.warn("Recharge widget not found after 10 tries. Applied logic anyway.");
        }
        return;
      }

      retryCount++;
      setTimeout(retryApplyOnLoad, retryInterval);
    };

    retryApplyOnLoad();
  }
});

function initNewFormUI(retries = 10) {
  const newForm = document.querySelector("#new-form");
  const cofre_kertox = document.querySelector(".cofre_kertox");
  console.log("retries", retries);
  console.log("newForm", newForm);
  if (!cofre_kertox) return;
  // Retry if #new-form not found yet
  if (!newForm) {
    if (retries > 0) {
      setTimeout(() => initNewFormUI(retries - 1), 1000);
    }
    return;
  }

  // ---- Once #new-form is available ----

  // Create cafre-box container
  const cafreBox = document.createElement("div");
  cafreBox.classList.add("cafre-box");
  newForm.prepend(cafreBox);

  // Function to update content inside cafre-box
  function updateCafreBox(optionElement) {
    cafreBox.innerHTML = optionElement.outerHTML;
  }

  // Select default selected item
  const defaultSelected = newForm.querySelector(".new-form-option.selectedWB");
  if (defaultSelected) updateCafreBox(defaultSelected);

  // Add click events to options
  const allOptions = newForm.querySelectorAll(".new-form-option");
  allOptions.forEach((option) => {
    option.addEventListener("click", function () {
      allOptions.forEach((o) => o.classList.remove("selectedWB"));
      this.classList.add("selectedWB");
      updateCafreBox(this);
    });
  });
}
document.addEventListener("DOMContentLoaded", function () {
  // Start the retry process
  console.log("initNewFormUI");
  initNewFormUI();
});

document.addEventListener("DOMContentLoaded", function () {
  if (
    window.location.pathname.endsWith("/new-mystery-box-atc") ||
    window.location.pathname.endsWith("/kertox-botox-capilar-instantaneo-mysterybox")
  ) {
    document.body.classList.add("atc-user-activatev2");
  }

  if (window.Shopify?.routes?.root === "/es-mx/") {
    const EUR_TO_MXN = 20.43; // 🔁 Static conversion rate

    // Regex to match all your formats
    const priceRegex = /(\d+(?:[.,]\d+)?)\s*€?\s*\/\s*ml|\d+(?:[.,]\d+)?€\/ml/gi;

    function convertText(node) {
      node.nodeValue = node.nodeValue.replace(priceRegex, function (match) {
        // Extract number (handles comma & dot)
        let value = match.match(/\d+(?:[.,]\d+)?/)[0];
        value = parseFloat(value.replace(",", "."));

        if (isNaN(value)) return match;

        const converted = (value * EUR_TO_MXN).toFixed(2);

        return `${converted} $ / ml`;
      });
    }

    function walk(node) {
      if (node.nodeType === Node.TEXT_NODE) {
        convertText(node);
      } else {
        node.childNodes.forEach(walk);
      }
    }

    setTimeout(function () {
      walk(document.body);
    }, 4000);
  }



  
});


(function() {
    var checkExist = setInterval(function() {
        if (window.location.pathname.includes('6-beneficios-2-efecto')) {

            var buttons = document.querySelectorAll('.fetaured-btn, .featured-btn');

            if (buttons.length > 0) {
                buttons.forEach(function(btn) {
                    btn.addEventListener('click', function(e) {
                        e.preventDefault();
                        e.stopPropagation();

                        fetch('/cart/add.js', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ id: 49466263798099, quantity: 1 })
                        })
                        .then(res => res.json())
                        .then(data => {
                            if (window.PXUTheme && window.PXUTheme.jsAjaxCart) {
                                window.PXUTheme.jsAjaxCart.updateView();
                                setTimeout(() => {
                                    window.PXUTheme.jsAjaxCart.showDrawer();
                                }, 400);
                            } else {
                                window.location.href = '/cart';
                            }
                        })
                        .catch(() => {});
                    });
                });

                clearInterval(checkExist);
            }
        } else {
            clearInterval(checkExist);
        }
    }, 100);
})();